import { produce } from 'immer';
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import type { GroupChannel } from '@sendbird/chat/groupChannel';
import { GroupChannelSearchField } from '@sendbird/chat/groupChannel';
import type { GroupChannelSearchFieldType } from '@consts/SendbirdConst';

interface ChannelListQueryState {
  searchFields: GroupChannelSearchFieldType[];
  searchValue?: string;
  userIds?: string[];
  channels?: GroupChannel[];
  limit?: number;
}

interface ChannelListQueryAction {
  setSearchValue: (value: string) => void;
  setUserIds: (userId: string) => void;
  setChannels: (channels: GroupChannel[]) => void;
  clearChannelListQuery: () => void;
}

const initialState: ChannelListQueryState = {
  /**
   * 미사용
   */
  searchFields: [GroupChannelSearchField.CHANNEL_NAME, GroupChannelSearchField.MEMBER_NICKNAME],
  searchValue: '',
  userIds: [],
  channels: [],
  limit: 100,
};

const useChannelListQueryStore = create<ChannelListQueryState & ChannelListQueryAction>()(
  devtools((set) => ({
    ...initialState,
    setSearchValue(value) {
      set(
        produce((draft: ChannelListQueryState) => {
          draft.searchValue = value;
        }),
      );
    },
    setUserIds(userId) {
      set(
        produce((draft: ChannelListQueryState) => {
          draft.userIds = [userId];
        }),
      );
    },
    setChannels(channels) {
      set(
        produce((draft: ChannelListQueryState) => {
          draft.channels = channels;
        }),
      );
    },
    clearChannelListQuery() {
      sessionStorage.removeItem('targetInviteUserId');
      set(initialState);
    },
  })),
);

export default useChannelListQueryStore;
